import { MdOutlineLoop } from "react-icons/md";
import { MESSAGE_TYPE } from "../../context/actionTypes";
import MarkDownFormater from "./MarkDownFormater";
import { IoArrowUp, IoCloseCircleOutline, IoCopyOutline } from "react-icons/io5";
import { VscEdit, VscFeedback } from "react-icons/vsc";
import { setBottomBarSucces } from "../../utils/Functions";
import { twMerge } from "tailwind-merge";
import { SlArrowDown, SlArrowUp } from "react-icons/sl";
import useAffichage from "../administration/manageTechnical/Affichage/useAffichage";
import DownButton from "./DownButton";
import styles from "./MessagesDisplayer.module.css";
import { ChatMessage, MessageState, RagOutput } from "../../types/chat";
import { Dispatch, KeyboardEventHandler, MutableRefObject, useEffect, useRef, useState } from "react";
import { Action } from "../../context/Context";
import ChatbotLoadingMessage from "./ChatbotLoadingMessage";
import { SourceDisplayer, SourceDisplayerProps } from "./SourceDisplayer";


type RagDisplayerProps = {
    index: number;
    message: ChatMessage;
    selectedMessage: number;
    setSelectedMessage: Dispatch<number>;
    displayRag: (rag: RagOutput, showPercentages: boolean) => void;
    companyUUID: string;
} & Omit<SourceDisplayerProps, "rag" | "clickAction">

interface AssistantMessageButtonsProps {
    index: number;
    message: ChatMessage;
    dispatch: Dispatch<Action>;
    handleRetry: (index: number) => void;
    createFeedback: (question: ChatMessage, response: ChatMessage) => void;
    messages: ChatMessage[];
    isWaitingForResponse: boolean;
}

interface UserErrorMessageButtonsProps {
    index: number;
    handleRetry: (index: number) => void;
}

type SingleMessageDisplayerProps = {
    index: number;
    message: ChatMessage;
    firstMessage: string;
    bottomRef: React.RefObject<HTMLDivElement>;
    selectedModifiedMessage: number | null;
    setselectedModifiedMessage: Function;
    handleKeyDown: KeyboardEventHandler<HTMLTextAreaElement>
    autoAdaptTextArea: Function;
    isLargerThanInitialOnModify: boolean;
    messageToSend: MutableRefObject<any>;
    handleModify: Function
} & Omit<RagDisplayerProps & AssistantMessageButtonsProps & UserErrorMessageButtonsProps, "index" | "message">;

type MessagesDisplayerProps = {
    bottomRef: React.RefObject<HTMLDivElement>;
    chatContainerRef: React.RefObject<HTMLDivElement>;
    firstMessage: string;
    statusMessage: string;
    messages: ChatMessage[];
} & Omit<SingleMessageDisplayerProps, "message" | "index" | "percentages" | "messages" | "firstMessage">


// Display the RAG footer with the show sources button
function RagDisplayer({ index, message, selectedMessage, setSelectedMessage, displayRag, percentages, companyUUID, ...props }: RagDisplayerProps) {
    return <div className="pt-2">
        <hr className="pt-2" />
        {selectedMessage === index ? (
            <>
                <div
                    className="text-sm font-semibold flex gap-1 items-center cursor-pointer"
                    onClick={() => setSelectedMessage(null)}>Sources
                    ({message?.rag?.length}) <SlArrowUp className="h-3 w-3" /></div>
                <div className={`pt-4 flex flex-col gap-2 ${styles.fade_in_top}`}>
                    {message?.rag?.map((rag, key) => (
                        <SourceDisplayer key={key} rag={rag} percentages={percentages} clickAction={() => displayRag(rag, percentages)} {...props} />
                    ))}
                </div>
            </>
        ) : (
            <div
                className="text-sm font-semibold flex gap-1 items-center cursor-pointer"
                onClick={() => setSelectedMessage(index)}
            >
                Sources ({message?.rag?.length})
                <SlArrowDown className="h-3 w-3" />
            </div>
        )
        }
    </div>;
}


function AssistantMessageButtons({ index, message, dispatch, handleRetry, createFeedback, messages, isWaitingForResponse }: AssistantMessageButtonsProps) {
    return <>
        <IoCopyOutline
            data-tooltip-id="chat-tooltip"
            data-tooltip-content={"Copier"}
            className="w-5 h-5 cursor-pointer hover:scale-110 transform duration-300 z-10 outline-none"
            onClick={() => {
                navigator.clipboard.writeText(message.message);
                setBottomBarSucces(dispatch, "Message copié");
            }}
        />
        {!isWaitingForResponse && (
            <MdOutlineLoop
                data-tooltip-id="chat-tooltip"
                data-tooltip-content={"Relancer"}
                className="w-5 h-5 cursor-pointer hover:scale-110 transform duration-300 z-10 outline-none"
                onClick={() => handleRetry(index - 1)}
            />
        )}
        <VscFeedback
            data-tooltip-id="chat-tooltip"
            data-tooltip-content={"Laisser un avis"}
            className="w-5 h-5 cursor-pointer hover:scale-110 transform duration-300 z-10 outline-none"
            onClick={() => createFeedback(messages[index - 1], message)}
        />
    </>;
}


function UserErrorMessageButtons({ index, handleRetry }: UserErrorMessageButtonsProps) {
    return <MdOutlineLoop
        data-tooltip-id="chat-tooltip"
        data-tooltip-content={"Réessayer"}
        className="w-5 h-5 cursor-pointer hover:scale-110 transform duration-300 z-10 outline-none"
        onClick={() => handleRetry(index)}
    />;
}


function SingleMessageDisplayer({ index, message, firstMessage, bottomRef, selectedModifiedMessage, setselectedModifiedMessage, autoAdaptTextArea, isLargerThanInitialOnModify, isWaitingForResponse, handleModify, ...props }: SingleMessageDisplayerProps) {
    if (index === 0) message.message = firstMessage;

    const messageTextContainerRef = useRef(null);
    const modifiedText = useRef(null)
    const [containerHeight, setContainerHeight] = useState("auto");
    const [isButtonDisabledOnModify, setisButtonDisabledOnModify] = useState(true);

    useEffect(() => {
        const handleResize = () => {
            if (messageTextContainerRef.current) {
                setContainerHeight(`${messageTextContainerRef.current.getBoundingClientRect().height}px`);
            }
        };

        const resizeObserver = new ResizeObserver(handleResize);
        if (messageTextContainerRef.current) {

            resizeObserver.observe(messageTextContainerRef.current);
        }

        // Clean up function
        return () => {
            if (messageTextContainerRef.current) {
                resizeObserver.unobserve(messageTextContainerRef.current);
            }
        };
    }, []);
    //Function to eacher show the message normaly or change the display to a textarea to change the message
    const modifyQuery = (index) => {
        if (selectedModifiedMessage === index) {
            setselectedModifiedMessage(null)
        }
        else {
            setselectedModifiedMessage(index)
        }
    }
    // Function to change if the send button is visible or not, same as the one in use chat just this time it disables the send button of the current modified text and not the main input textbar
    const handleMessageChange = (event) => {
        if (event.target?.value.trim() === "" || isWaitingForResponse) {
            setisButtonDisabledOnModify(true);
        } else {
            setisButtonDisabledOnModify(false);
        }
    };
    // Function to adapt the height of the selected message on click
    useEffect(() => {
        autoAdaptTextArea(modifiedText)
    }, [selectedModifiedMessage])
    // Function to either send the messagge when Enter is hit, or adapt the height of the textarea, this function is the same as the one in useChat but this time it's for textModification
    const handleKeyDown = (event, index) => {
        if (event.key === "Enter" && !event.shiftKey) {
            event.preventDefault();
            handleModify(index, modifiedText);
        }
        autoAdaptTextArea(event);
    };


    return message?.type && (
        <div className="text-gray-800 pt-4">
            <div className="flex items-start gap-5 pb-3">
                <div className="pt-3 w-6 h-6">
                    <img
                        src={message?.type === MESSAGE_TYPE.HUMAN ? (message.state === MessageState.ERROR ? "/user_error.svg" : "/user.svg") : "/chatbot-black.svg"}
                        alt="user" className="w-full flex-shrink-0" />
                </div>
                {!(selectedModifiedMessage === index) ? <div
                    key={index} className={`${styles.message} fadeIn ${twMerge(`${message.type === MESSAGE_TYPE.HUMAN ? (message.state === MessageState.ERROR ? "bg-figmaColors-chatbotErrorMessage text-trueGray-500" : "bg-figmaColors-chatbotUserMessage") : "bg-figmaColors-chatbotAssistantMessage"} p-4 font-light rounded-r-xl rounded-bl-xl shadow-lg transform duration-500 w-full`)}`}>
                    <div className="relative">
                        <div className="absolute w-full" ref={messageTextContainerRef}>
                            <MarkDownFormater>
                                {message.message}
                            </MarkDownFormater>
                        </div>
                        <div className="transition-all" style={{ height: containerHeight }}></div>
                    </div>
                    {message.type === MESSAGE_TYPE.MACHINE && message?.rag?.length > 0 && <RagDisplayer index={index} message={message} {...props} />}
                </div> :
                    <div
                        className={` relative  w-full border border-gray-400 shadow rounded-2xl transform duration-300 flex items-center overflow-hidden `}>
                        <textarea
                            className={`py-4 pr-12 text-xs sm:text-base px-3 flex-grow w-full outline-none max-h-48 bg-transparent resize-none overflow-y-auto bg-white text-black`}
                            tabIndex={0}
                            placeholder="Entrez votre message..."
                            rows={1}
                            ref={modifiedText}
                            defaultValue={message.message}
                            onKeyDown={(e) => handleKeyDown(e, index)}
                            onInput={(e) => autoAdaptTextArea(e)}
                            onChange={(e) => handleMessageChange(e)}
                            key={index}
                        />
                        <div
                            className={twMerge(`${isLargerThanInitialOnModify ? ' items-end' : ' items-center'} absolute h-full top-0 right-0 flex p-2`)}>
                            <button disabled={isButtonDisabledOnModify}
                                className={twMerge(`cursor-pointer h-8 w-8 rounded-lg disabled:opacity-50 disabled:pointer-events-none bg-gray-500 disabled:hover:bg-none hover:bg-gray-600 transform duration-500 flex items-center justify-center`)} onClick={() => handleModify(index, modifiedText)}>
                                <IoArrowUp className="  h-5 w-5 text-white"

                                />
                            </button>
                        </div>
                    </div>}
            </div>
            <div className="flex gap-3 justify-end pb-3">
                {index > 0 && <>
                    {message.type === MESSAGE_TYPE.MACHINE && message.state !== MessageState.PROCESSING &&
                        <AssistantMessageButtons isWaitingForResponse={isWaitingForResponse} index={index} message={message} {...props} />}
                    {message.type === MESSAGE_TYPE.HUMAN && ((selectedModifiedMessage !== index) ?
                        <VscEdit
                            data-tooltip-id="chat-tooltip"
                            data-tooltip-content={"Modifier"}
                            className="w-5 h-5 cursor-pointer hover:scale-110 transform duration-300 z-10 outline-none"
                            onClick={() => modifyQuery(index)}
                        />
                        : !isWaitingForResponse &&
                        <IoCloseCircleOutline
                            data-tooltip-id="chat-tooltip"
                            data-tooltip-content={"Annuler"}
                            className="w-5 h-5 cursor-pointer hover:scale-110 transform duration-300 z-10 outline-none"
                            onClick={() => modifyQuery(index)}
                        />)}
                    {message.state === MessageState.ERROR && <UserErrorMessageButtons index={index} {...props} />}
                </>}
            </div>
        </div>
    );
}

export default function MessagesDisplayer(
    { bottomRef, chatContainerRef, firstMessage, statusMessage, messages, isWaitingForResponse, selectedModifiedMessage, setselectedModifiedMessage, handleKeyDown, autoAdaptTextArea, isLargerThanInitialOnModify, messageToSend, handleModify, ...props }: MessagesDisplayerProps,
) {
    messages?.length <= 0 && messages.push({ message: firstMessage, type: MESSAGE_TYPE.MACHINE });
    const [{percentages}] = useAffichage();
    return <div className={`w-full max-w-screen-lg mx-auto px-4`}>
        {messages.map((message, index) => <SingleMessageDisplayer
            key={index}
            message={message}
            index={index}
            percentages={percentages}
            messages={messages}
            firstMessage={firstMessage}
            bottomRef={bottomRef}
            isWaitingForResponse={isWaitingForResponse}
            selectedModifiedMessage={selectedModifiedMessage}
            setselectedModifiedMessage={setselectedModifiedMessage}
            handleKeyDown={handleKeyDown}
            autoAdaptTextArea={autoAdaptTextArea}
            isLargerThanInitialOnModify={isLargerThanInitialOnModify}
            messageToSend={messageToSend}
            handleModify={handleModify}
            {...props}
        />)}
        {statusMessage != null && <ChatbotLoadingMessage statusMessage={statusMessage} addTopPadding={true} />}

        <DownButton bottomRef={bottomRef} chatContainerRef={chatContainerRef} messages={messages} />
        <div ref={bottomRef} />
    </div>;
}